import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        productDelete: builder.mutation({
            query: (id: string) => ({
                url: `/product/delete-product/` + id,
                method: 'DELETE',
                header: {},
            }),
        }),

        productArchive: builder.mutation({
            query: (productId: string) => ({
                url: `/product/archive/` + productId,
                method: 'PATCH',
                header: {},
            }),
        }),
    }),
});

export const { useProductDeleteMutation, useProductArchiveMutation } =
    importTradeDataApiSlice;
